/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

// LOLCALIZE=1 mangling; like i18nLolcalize.js but also keeps {{var}} intact.
const formatter = {
  0: 'toUpperCase',
  1: 'toLowerCase',
} as const

// Skip placeholders, wrappers, and leading whitespace.
const PRESERVE_PATTERN =
  /(\s*%h?\{[^}]+\}\s*|\s*\{\{[^}]+\}\}\s*|\s*[\n\\`*_{}\[\]()#+\-!]+\s*|^\s+)/

function letThereBeLols(str: string): string {
  return str
    .split(PRESERVE_PATTERN)
    .map(token => {
      if (token.match(PRESERVE_PATTERN)) return token
      let s = ''
      for (let i = 0; i < token.length; i++) {
        const method = formatter[(i % 2) as 0 | 1]
        s += token[i][method]()
      }
      s = s.replace(/\.( |$)/, '!!?! ')
      s = s.replace(/^(\w+)$/, '$1!')
      if (s.length > 2) s += ' LOL!'
      return s
    })
    .join('')
}

export function isLolcalizeEnabled(): boolean {
  return typeof window !== 'undefined' && Boolean(window.ENV?.lolcalize)
}

export function lolcalize(strOrObj: string): string
export function lolcalize<T extends Record<string, string>>(strOrObj: T): T
export function lolcalize(
  strOrObj: string | Record<string, string>,
): string | Record<string, string> {
  if (typeof strOrObj === 'string') return letThereBeLols(strOrObj)

  const result: Record<string, string> = {}
  for (const key of Object.keys(strOrObj)) {
    result[key] = letThereBeLols(strOrObj[key])
  }
  return result
}
